import React from 'react';
import styles from './index.module.css';

const Loader = () => <div className={styles.loader} />;

export default Loader;
